import "./style.scss";
import $ from "jquery";

$.migrateMute = true;

$(document).ready(function () {

    $('.faq-accordion ').find('.ow_accordion_toggle').click(function(){
        if ($(this).hasClass( "active" )) {
            $('.ow_accordion_toggle').removeClass("active");
            $(this).next().slideUp('fast').removeClass("active");
        }
        else {
            $('.ow_accordion_toggle').removeClass("active");
            $(this).addClass("active");
            $(this).next().slideToggle('fast').addClass("active");
            //Hide the other panels
            $(".ow_accordion_content").not($(this).next()).slideUp('fast').removeClass("active");
        }
    });

    if ($('.block_faq_tab').length) {
        $('.block_faq_tab').each(function () {
            var wrap = $(this);
            wrap.find(".faq_tab_menu_single:first-child").addClass("active");
            wrap.find(".faq_tab_single:first-child .faq_tab_single_content").slideDown('fast');
            wrap.find(".faq_tab_single:first-child").addClass("active");
        });

        $('.faq_tab_single').each(function () {
            var wrap = $(this);
            wrap.find(".ow_accordion_single").slice(0, 4).show();
            wrap.on("click", ".faq_tab_single_load_more", function(){
                wrap.find(".ow_accordion_single:hidden").slice(0, 4).slideDown();
                if(wrap.find(".ow_accordion_single:hidden").length == 0) {
                    wrap.find(".faq_tab_single_load_more").hide();
                }
            });
        });
    }

    $('.block_faq_tab').on('click', '.faq_tab_menu_single', function () {
        var wrap = $(this).closest('.block_faq_tab');
        if (!$(this).hasClass("active")) {
            var clickClass = $(this).data("class");
            wrap.find('.faq_tab_menu_single').removeClass("active");
            wrap.find('.faq_tab_single_content ').slideUp('fast');
            wrap.find('.faq_tab_single').removeClass("active");
            $(this).addClass("active");
            $('.' + clickClass + ' .faq_tab_single_content').slideToggle('fast');
            $('.' + clickClass).addClass("active");
        }
    });
    $('.block_faq_tab').on('click', '.faq_tab_single_mobile_title', function () {
        var wrap = $(this).closest('.block_faq_tab');
        var wrap_single = $(this).closest('.faq_tab_single');
        if (!wrap_single.hasClass("active")) {
            var clickClass = $(this).data("click");
            wrap.find('.faq_tab_menu_single').removeClass("active");
            wrap.find('.faq_tab_single_content ').slideUp('fast');
            wrap.find('.faq_tab_single').removeClass("active");
            wrap_single.addClass("active");
            $('.' + clickClass + ' .faq_tab_single_content').slideToggle('fast');
            $('.' + clickClass).addClass("active");
        }
    });
});